module.exports = __webpack_public_path__ + "static/media/ahi-pi-moderate-risk.33a0ad97.svg";